/* eslint-disable import/prefer-default-export */
import {
  getSkuDetailsAPIKey,
  getTestSeriesDetailsAPIKey
} from '@cont/SeeAll/utils';
import fetcher, { simpleFetch as fetch } from '@api/fetchers';
import { getHost, HOST_TYPE } from '@utils/api-helper/host';

const testSeriesHost = getHost(HOST_TYPE.TEST_SERIES);
const backendHost = getHost(HOST_TYPE.BACKEND_API_HOST);

export const getScheduleInfoKey = (courseUID = '') =>
  `${testSeriesHost}test-series-svc/collection/v1/${courseUID}/schedule`;

export const fetchScheduleCard = (
  courseUID,
  next = null,
  authorization = null
) => {
  if (next) {
    return fetch(next, false, authorization);
  }
  return fetch(getScheduleInfoKey(courseUID));
};

export const fetchTestSeriesDetails = (uid) => {
  return fetch(`${testSeriesHost}${getTestSeriesDetailsAPIKey(uid)}`);
};

export const fetchSkuDetails = (testSeriesUID, goalUID) => {
  return fetch(`${backendHost}${getSkuDetailsAPIKey(testSeriesUID, goalUID)}`);
};

export const unsaveItem = (objectUid, entityType) =>
  fetcher('v1/uplus/save/remove_saved_item/', {
    requestType: 'POST',
    body: {
      object_uid: objectUid,
      entity_type: entityType
    }
  });

export const saveItem = (objectUid, entityType) =>
  fetcher('v1/uplus/save/save_item/', {
    requestType: 'POST',
    body: {
      object_uid: objectUid,
      entity_type: entityType
    }
  });
